import selectImportor from './selectImportor.vue'

export default selectImportor;


// WEBPACK FOOTER //
// ./src/components/customComponents/selectImportor/index.js